import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';

const TITLE_MAP: { match: (p: string) => boolean; title: string; desc: string }[] = [
  {
    match: (p) => p === '/',
    title: '桃花漫画网 - 恋爱漫画在线看，古风恋爱漫画免费阅读',
    desc: '古风恋爱、现代言情、甜宠少女漫画分类齐全，热门恋爱漫画实时更新，免费章节多，追更不迷路。',
  },
  {
    match: (p) => p.startsWith('/category'),
    title: '恋爱漫画分类浏览 - 桃花漫画网',
    desc: '桃花漫画网全部恋爱漫画分类，古风恋爱、现代言情、甜宠少女、校园青春，热门作品实时更新。',
  },
  {
    match: (p) => p.startsWith('/ranking'),
    title: '排行榜 - 桃花漫画网',
    desc: '桃花漫画网恋爱漫画人气榜、高分榜、完结榜，热门言情漫画推荐，追更不迷路。',
  },
  {
    match: (p) => p.startsWith('/about'),
    title: '关于我们 - 桃花漫画网',
    desc: '桃花漫画网专注恋爱言情漫画在线阅读，提供古风恋爱、现代言情、甜宠少女漫画分类与实时更新服务。',
  },
];

function usePageSeo() {
  const { pathname } = useLocation();
  useEffect(() => {
    const hit = TITLE_MAP.find((t) => t.match(pathname));
    if (hit) {
      document.title = hit.title;
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute('content', hit.desc);
    }
  }, [pathname]);
}

function BackToTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <>
      {visible && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="返回顶部"
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-soft transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-lg" />
        </button>
      )}
    </>
  );
}

export default function Layout() {
  usePageSeo();
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <ScrollToTop />
      <Navbar />
      <main className="flex-1 pt-16 md:pt-[72px]">
        <Outlet />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}